export default "__VITE_ASSET__DAaC3t_k__"